import { FC } from "react";
import { SortOrder } from "../../../../store/superadmin/referral/types";
import { AcceptedVacancySortField } from "../../../../store/vacancy/types";
import Sort from "../../../UI/Icons/Sort";

export interface IAcceptedTableHeaderProps {
  sortBy: AcceptedVacancySortField;
  sortOrder: SortOrder;
  onSortChange: (field: AcceptedVacancySortField) => void;
}

const AcceptedTableHeader: FC<IAcceptedTableHeaderProps> = ({
  sortBy,
  sortOrder,
  onSortChange,
}) => {
  return (
    <div className="bg-white py-10px px-15px d-none d-lg-flex flex-column flex-lg-row gap-10 align-items-start align-items-lg-center justify-content-between border-bottom border-off-white fs-13 fw-400 text-black">
      <div className="flex-grow-1"></div>
      <div className="min-w-250px d-flex gap-20 align-items-center">
        <div className="w-50px d-none d-lg-block"></div>
        <div
          className="d-flex gap-5 align-items-center cursor-pointer"
          onClick={() => onSortChange("candidate")}
        >
          <div className="fs-13 fw-700">Candidate</div>
          <Sort active={sortBy === "candidate"} direction={sortOrder} />
        </div>
      </div>
      <div
        className="min-w-250px d-flex gap-5 align-items-center cursor-pointer"
        onClick={() => onSortChange("timeframe")}
      >
        <div className="fs-13 fw-700">Requested Timeframe</div>
        <Sort active={sortBy === "timeframe"} direction={sortOrder} />
      </div>
      <div
        className="min-w-120px d-flex gap-5 align-items-center cursor-pointer"
        onClick={() => onSortChange("accepted")}
      >
        <div className="fs-13 fw-700">Accepted</div>
        <Sort active={sortBy === "accepted"} direction={sortOrder} />
      </div>
      <div className="min-w-165px"></div>
      <div className="min-w-24px"></div>
    </div>
  );
};

export default AcceptedTableHeader;
